import CounterpartyContent from './CounterpartyContent';

export default CounterpartyContent;
